// Local translations
export const T = {
  en_GB: {
    portfolioSourceDesc:
      "Existing portfolio lists the client's holdings before advice. It applies in follow up sessions; other sessions show the new portfolio.",
  },
  nb_NO: {
    portfolioSourceDesc:
      "Eksisterende portefølje viser kundens beholdning før rådgivning. Gjelder i oppfølgingsøkter; andre økter viser den nye porteføljen.",
  },
} as const;
